import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../service/local-storage.service';
import { LocalStorageEnum } from '../../shared/enum.ts/local-storage.enum';

/**
 * Allows users with `SUPER_ADMIN` or `STORE_ADMIN` roles. The legacy name
 * was `superAdminGuard` which misled — the gate has always permitted both
 * admin tiers. Renamed per implementation-guidelines §10.3.
 */
export const adminGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const user = localStorageService.getItem(LocalStorageEnum.USER);

  if (user && (user.roleName === 'SUPER_ADMIN' || user.roleName === 'STORE_ADMIN')) {
    return true;
  }

  return false;
};
